import { useCallback } from "react";

/**
 * バックエンドで定義している権限コード
 */
export const HostRole_Hotel_Forbidden = "HostRole_Hotel_Forbidden";
const CHILLNN_ROLE_CODE = [HostRole_Hotel_Forbidden];

export const useChillnnApplicationErrorHandler = () => {
	/**
	 * CHILLNN Error を trhow する
	 * @example
	 * ```ts
	 * バックエンド側から共通で定義しているエラーコードを catch したケース
	 * onThrowCHILLNNError({
	 *   status: 403,
	 *   statusText: "HostRole_Hotel_Forbidden",
	 * });
	 */
	const onThrowChillnnApplicationError = useCallback(
		({ status, statusText }: { status: number; statusText: string }) => {
			throw new Response(undefined, { status, statusText });
		},
		[],
	);
	/**
	 * CHILLNN で定義した ErrorResponse ではない Error を throw する
	 */
	const onThrowChillnnApplicationStandardError = useCallback(() => {
		onThrowChillnnApplicationError({ status: 500, statusText: "システムエラーが発生しました。" });
	}, [onThrowChillnnApplicationError]);
	/**
	 * CHILLNN で定義した Error か判定
	 */
	const onConfirmIsChillnnApplicationError = useCallback(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(error: any): error is { status: number; statusText: string } => {
			return "status" in error && "statusText" in error;
		},
		[],
	);
	/**
	 * CHILLNN で定義した RoleCode か判定
	 */
	const onConfirmIsChillnnApplicationRoleCode = useCallback((code: string | undefined): boolean => {
		return CHILLNN_ROLE_CODE.includes(code ?? "");
	}, []);

	/**
	 * 前回の Error を含む、Error を再度 throw する
	 * @example
	 * ```ts
	 * Node でのエラー処理で、前回のエラー情報を含めて再度 throw したいケース
	 * onThrowBubbleUpError({
	 *  errorMessage: "エラーが発生しました",
	 *  cause: error, // 前回発生した Error();
	 * });
	 * ```
	 */
	const onThrowBubbleUpError = useCallback(({ errorMessage, cause }: { errorMessage: string; cause?: unknown }) => {
		throw new Error(errorMessage, { cause });
	}, []);
	/**
	 * Error に cause があるか判定
	 */
	const hasCauseOfError = useCallback((error: unknown) => {
		// eslint-disable-next-line no-prototype-builtins
		return error?.hasOwnProperty("cause");
	}, []);

	return {
		onThrowChillnnApplicationError,
		onThrowChillnnApplicationStandardError,
		//
		onConfirmIsChillnnApplicationError,
		onConfirmIsChillnnApplicationRoleCode,
		//
		onThrowBubbleUpError,
		hasCauseOfError,
	};
};
